import { createSelector } from '@ngrx/store';
import { IDeliveryServiceState } from './delivery-service.reducer';

const deliveryServiceStore = (state: any) =>
  state.deliveryService as IDeliveryServiceState;

export const selectDeliveryServiceLista = createSelector(
  deliveryServiceStore,
  (state) => state.lista
);

export const selectDeliveryServiceLoading = createSelector(
  deliveryServiceStore,
  (state) => state.isLoading
);
